'use strict';

var _each2 = _interopRequireDefault(require("lodash/each"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (schema) {
  var _this = this;

  if ((0, _isArray2.default)(schema)) {
    schema = schema[0];
  }

  if (!schema.$) {
    schema.$ = {};
  }

  if (schema.$.uniques === undefined) {
    schema.$.uniques = [];
    (0, _each2.default)(schema, function (value, key) {
      if (value instanceof _this.classes.Type && value.unique) {
        schema.$.uniques.push(key);
      }
    });
  }

  return schema.$.uniques;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vc2NoZW1hVW5pcXVlcy5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwic2NoZW1hIiwiJCIsInVuaXF1ZXMiLCJ1bmRlZmluZWQiLCJ2YWx1ZSIsImtleSIsImNsYXNzZXMiLCJUeXBlIiwidW5pcXVlIiwicHVzaCJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7O0FBSUFBLE9BQU9DLE9BQVAsR0FBaUIsVUFBVUMsTUFBVixFQUFtQjtBQUFBOztBQUVuQyxNQUFLLHVCQUFXQSxNQUFYLENBQUwsRUFBMkI7QUFFMUJBLGFBQVNBLE9BQVEsQ0FBUixDQUFUO0FBRUE7O0FBRUQsTUFBSyxDQUFDQSxPQUFPQyxDQUFiLEVBQWlCO0FBRWhCRCxXQUFPQyxDQUFQLEdBQVcsRUFBWDtBQUVBOztBQUVELE1BQUtELE9BQU9DLENBQVAsQ0FBU0MsT0FBVCxLQUFxQkMsU0FBMUIsRUFBc0M7QUFFckNILFdBQU9DLENBQVAsQ0FBU0MsT0FBVCxHQUFtQixFQUFuQjtBQUVBLHdCQUFRRixNQUFSLEVBQWdCLFVBQUVJLEtBQUYsRUFBU0MsR0FBVCxFQUFrQjtBQUVqQyxVQUFLRCxpQkFBaUIsTUFBS0UsT0FBTCxDQUFhQyxJQUE5QixJQUFzQ0gsTUFBTUksTUFBakQsRUFBMEQ7QUFFekRSLGVBQU9DLENBQVAsQ0FBU0MsT0FBVCxDQUFpQk8sSUFBakIsQ0FBdUJKLEdBQXZCO0FBRUE7QUFFRCxLQVJEO0FBVUE7O0FBRUQsU0FBT0wsT0FBT0MsQ0FBUCxDQUFTQyxPQUFoQjtBQUVBLENBaENEIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG5pbXBvcnQgXyBmcm9tICdsb2Rhc2gnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKCBzY2hlbWEgKSB7XG5cblx0aWYgKCBfLmlzQXJyYXkoIHNjaGVtYSApICkge1xuXG5cdFx0c2NoZW1hID0gc2NoZW1hWyAwIF07XG5cblx0fVxuXG5cdGlmICggIXNjaGVtYS4kICkge1xuXG5cdFx0c2NoZW1hLiQgPSB7fTtcblxuXHR9XG5cblx0aWYgKCBzY2hlbWEuJC51bmlxdWVzID09PSB1bmRlZmluZWQgKSB7XG5cblx0XHRzY2hlbWEuJC51bmlxdWVzID0gW107XG5cblx0XHRfLmVhY2goIHNjaGVtYSwgKCB2YWx1ZSwga2V5ICkgPT4ge1xuXG5cdFx0XHRpZiAoIHZhbHVlIGluc3RhbmNlb2YgdGhpcy5jbGFzc2VzLlR5cGUgJiYgdmFsdWUudW5pcXVlICkge1xuXG5cdFx0XHRcdHNjaGVtYS4kLnVuaXF1ZXMucHVzaCgga2V5ICk7XG5cblx0XHRcdH1cblxuXHRcdH0gKTtcblxuXHR9XG5cblx0cmV0dXJuIHNjaGVtYS4kLnVuaXF1ZXM7XG5cbn07Il19